export const costCenterTag = 'costCenter:';
